export enum Config {
	apiUrl = '/api',
	taxFormAlertCap = 500,
	yearlyTotalCap = 600
}